
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

interface LegalNoticeProps {
  isOpen: boolean;
  onClose: () => void;
}

const LegalNotice: React.FC<LegalNoticeProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-dark/90 backdrop-blur-md"
          />
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-2xl glass rounded-[2rem] p-10 lg:p-16 border-white/10 shadow-2xl overflow-hidden"
          >
            <button 
              onClick={onClose}
              className="absolute top-8 right-8 text-white/40 hover:text-gold transition-colors"
            >
              <X size={24} />
            </button>

            <h2 className="text-3xl font-serif font-bold mb-8">Mentions Légales</h2>
            
            <div className="space-y-8 text-white/60 text-sm leading-relaxed">
              <section>
                <h3 className="text-gold font-bold uppercase tracking-widest text-[10px] mb-4">Identification</h3>
                <p>Micro-Entreprise : <span className="text-white">Issa DIOUF / DJ SAFF</span></p>
                <p>SIRET : <span className="text-white">52303280300034</span></p>
                <p>Siège Social : <span className="text-white">Cadenet 84160, France</span></p>
              </section>

              <section>
                <h3 className="text-gold font-bold uppercase tracking-widest text-[10px] mb-4">Contact</h3>
                <p>Responsable de la publication : <span className="text-white">Issa DIOUF</span></p>
                <p>Email : <span className="text-white">contact@djsaff.com</span></p>
                <p>Téléphone : <span className="text-white">07.71.74.42.04</span></p>
              </section>

              <section>
                <h3 className="text-gold font-bold uppercase tracking-widest text-[10px] mb-4">Hébergement</h3>
                <p>Ce site est un showcase exclusif pour l'artiste DJ SAFF.</p>
              </section>

              <section className="pt-6 border-t border-white/5">
                <p className="text-[10px] italic">
                  Conformément à la loi informatique et libertés, vous disposez d'un droit d'accès et de rectification aux données vous concernant.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default LegalNotice;
